import * as React from "react";
import { FormattedMessage } from "react-intl";
import useWindowSize from "../../CustomHooks/useWindowSize";
import DeviceSelector from "../../Selectors/DeviceSelector";
import CountrySelector from "../CountrySelector";
import { useMatch } from "react-router-dom";
var Header = function () {
  var subline;
  var width = useWindowSize();
  var routeMatch = useMatch("/profil/:name/");
  var routeMatch2 = useMatch("/telefonsex/");
  if (width <= 751 && routeMatch !== null) {
    return /*#__PURE__*/React.createElement("div", {
      className: "headline grid-100 grid-parent inProfile c-headline"
    }, /*#__PURE__*/React.createElement("div", {
      className: "logoline c-headline__logo"
    }, /*#__PURE__*/React.createElement("div", {
      className: "prodwidth center l-container h-center"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/"
    }, /*#__PURE__*/React.createElement("h1", null, "BeiAnrufSex.com")))), /*#__PURE__*/React.createElement("div", {
      className: "selectors c-headline__selectors"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CountrySelector, {
      hideText: true
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeviceSelector, null))));
  }
  subline = /*#__PURE__*/React.createElement(React.Fragment, null, "Livecam-Sex sofort & ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "kostenlos"
  }), " !");
  var introText = /*#__PURE__*/React.createElement(React.Fragment, null, "Du zahlst nur die Telefonkosten. Den Code f\u00FCr die ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "kostenlose"
  }), "\u00A0 Live-Cam bekommst du vom ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Girl"
  }), " am Telefon.");
  if (routeMatch2 !== null) {
    subline = /*#__PURE__*/React.createElement(React.Fragment, null, "Telefon-Sex diskret, anonym & hei\u00DF!");
    introText = /*#__PURE__*/React.createElement(React.Fragment, null, "Stimmen zum Verf\u00FChren");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "headline grid-100 grid-parent c-headline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logoline c-headline__logo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center l-container h-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, /*#__PURE__*/React.createElement("h1", null, "BeiAnrufSex.com")), /*#__PURE__*/React.createElement("div", {
    id: "languagePosition",
    className: "c-language-positioner"
  }, /*#__PURE__*/React.createElement(CountrySelector, null)), /*#__PURE__*/React.createElement("div", {
    className: "infobadge hide-on-mobile hide-on-tablet c-headline__badge"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center push-top gridreplace c-headline__intro l-container h-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "subline c-headline__subline"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "grid-100"
  }, subline), /*#__PURE__*/React.createElement("h3", {
    className: "grid-50 tablet-grid-80 mobile-grid-100"
  }, introText)), /*#__PURE__*/React.createElement("div", {
    className: "bggirl2 a".concat(window.age, " c-headline__girl2")
  })), /*#__PURE__*/React.createElement("div", {
    className: "bggirl a".concat(window.age, " c-headline__girl")
  }));
};
export default Header;